import type { Step } from '@/components/wizard/Step';
import type { ChartType, ColumnMapping, GraphLayout } from '@/types/dashboard';

import { GraphEditorStep } from './steps/graphEditorStep';

export interface GraphWizardState {
  workspaceId: string;
  dashboardId: string;
  graphId?: string;
  title: string;
  chartType: ChartType;
  sqlQuery: string;
  columnMapping: ColumnMapping;
  layout: GraphLayout;
}

export const CreateGraphFlow: Step<GraphWizardState> = {
  id: 'graph_editor',
  Component: GraphEditorStep,
};
